module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "myBody",
    class: _vm.bodyClass
  }, [_c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-07e0cb04!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 35
// module chunks = 1